export default function log(s) {
  console.info('[react-ga]', s);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-ga/dist/esm/utils/console/log.js
// module id = 1037
// module chunks = 0